import {
  AppMinimumRequirementsForRecaptcha,
  emailAddressFormLogic,
  GenericForm,
  GenericFormLogic,
  recaptchaFormLogic,
} from "../../../Common";

import { ReactForgotPasswordInitialStateInterface } from "../react-forgot-password-initial-state-provider";

export interface ForgotPasswordForm extends GenericForm {
  email?: string;
}

export interface ForgotPasswordFormApp
  extends AppMinimumRequirementsForRecaptcha {
  initialState: ReactForgotPasswordInitialStateInterface;
}

export const ForgotPasswordFormLogic: GenericFormLogic<
  ForgotPasswordForm,
  ForgotPasswordFormApp
> = {
  email: emailAddressFormLogic({ required: true }),

  recaptcha: recaptchaFormLogic<ForgotPasswordForm, ForgotPasswordFormApp>({
    initialStateKey: "forgot_password_form_recaptcha",
  }),
} as const;

export const ForgotPasswordFormInitialState = (): ForgotPasswordForm => ({});
